import { ChatMessage, Conversation, ToolCall } from '../types';
import { ConversationDto, MessageDto } from '../api/conversations';

export function fmtTime(iso: string): string {
  return new Date(iso).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export function dbConvToLocal(dbConv: ConversationDto, messages: ChatMessage[] = []): Conversation {
  return {
    id: dbConv.id,
    title: dbConv.title ?? 'Untitled',
    agentId: dbConv.primaryAgentId ?? '',
    lastAgentId: dbConv.lastAgentId ?? '',
    lastMessageAt: dbConv.lastMessageAt,
    messages,
  };
}

export function dtoToChatMessage(m: MessageDto): ChatMessage {
  return {
    id: m.id,
    role: m.role === 'user' ? 'user' : 'assistant',
    content: m.content,
    agentId: m.agentId ?? undefined,
    timestamp: fmtTime(m.createdAt),
    toolCalls: (m.toolCalls as ToolCall[] | undefined) ?? undefined,
    feedback: m.feedback ?? undefined,
  };
}

// No client-side wire conversion: the agent transcript is built server-side by
// storedHistoryToWire() in routes/conversations.ts.
